var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.show)?_c('div',{staticClass:"nobox"},[_c('el-link',{staticClass:"nodata",attrs:{"disabled":""}},[_c('img',{attrs:{"src":"/Public/home/images/nodata.png"}}),_vm._v(" 暂无数据")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }